import { theme } from 'modules/ui/theme';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import {
  NavigationAndActionArrowDown,
  NavigationAndActionProfile,
} from 'modules/ui/icons';
import { setIconColor } from 'modules/utils/cssUtils';

export const StyledProfileItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaQuery('md')} {
    align-items: flex-end;
  }

  &:hover {
    ${({theme}) => setIconColor(theme.colors.primaryK7)}
  }
`;

export const StyledProfileIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  height: 1.75rem;
  min-width: 1.75rem;

  ${mediaQuery('md')} {
    height: 1.4rem;
    margin-bottom: 0.2rem;
  }
`;

export const StyledProfileIcon = styled(NavigationAndActionProfile)`
  height: 100%;
  max-width: 100%;
  width: auto;
  fill: ${({theme}) => theme.colors.primaryK10};
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const StyledNotificationCountCircle = styled.div`
  background-color: ${({theme}) => theme.colors.primaryT2};
  color: ${({theme}) => theme.colors.primaryW};
  font-weight: ${theme.fontWeight.bold};
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid ${({theme}) => theme.colors.primaryW};
  position: absolute;
  top: -6px;
  left: -6px;
  font-size: 0.7rem;
`;

export const StyledProfileDropdown = styled.div`
  text-transform: uppercase;
  font-size: var(--h5-font-size);
  color: ${({theme}) => theme.colors.primaryK10};
  font-weight: ${theme.fontWeight.bold};
  display: none;

  ${mediaQuery('md')} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledArrowDownIcon = styled(NavigationAndActionArrowDown)`
  height: 0.6rem;
  width: 0.6rem;
  margin-left: 0.4rem;
`;
